import React, { useState, useMemo } from "react";
import { Avatar, Modal, Popover } from "antd";
import { useAuth } from "../../authentication";
import { useHistory } from "react-router-dom";
import DefaultUsericon from "../../assets/Images/default-user-icon.png";
import ChangePassword from "../../containers/Pages/ChangePassword";

const UserInfo = () => {
  const { userSignOut, userChangePassword } = useAuth();
  const [isChangePasswordModalVisible, setChangePasswordModalVisible] =
    useState(false);
  const history = useHistory();
  const [resetKey, setResetKey] = useState(0);

  const onLogoutClick = () => {
    userSignOut(() => {
      history.push("/");
    });
  };

  const onChangePassword = () => {
    showChangePasswordModal();
  };

  const showChangePasswordModal = () => {
    setChangePasswordModalVisible(true);
    // Increment the reset key to trigger a reset of the ChangePassword component
    setResetKey((prevKey) => prevKey + 1);
  };

  const hideChangePasswordModal = () => {
    setChangePasswordModalVisible(false);
  };

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li onClick={onChangePassword}>Change password</li>
      <li onClick={onLogoutClick}>Logout</li>
    </ul>
  );

  const handleFormSubmit = (values) => {
    userChangePassword(values);
  };

  // Generate a unique key for the ChangePassword component
  const changePasswordKey = useMemo(() => resetKey, [resetKey]);

  return (
    <div>
      <Popover
        overlayClassName="gx-popover-horizantal"
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
      >
        <Avatar src={DefaultUsericon} className="gx-avatar gx-pointer" alt="" />
      </Popover>

      <Modal
        title={<span className="password-title">Change Password</span>}
        open={isChangePasswordModalVisible}
        onCancel={hideChangePasswordModal}
        footer={null}
      >
        <ChangePassword onFinish={handleFormSubmit} key={changePasswordKey} />
      </Modal>
    </div>
  );
};

export default UserInfo;
